import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    STATUS_AUTH,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/status',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/status/StatusCreateView')),
    },
    {
        exact: true,
        path: '/management/status/:id',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/status/StatusDetailsView')),
    },

    {
        exact: true,
        path: '/management/status/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/status/StatusEditView')),
    },
    {
        exact: true,
        path: '/management/status',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/status/StatusListView')),
    },
];
